module.exports = __webpack_public_path__ + "img/pronged-driftwood-1.a7d3c235.jpg";